import React, { useState, useEffect } from "react";
import axios from "axios";
import AOS from "aos";
import "aos/dist/aos.css";
import { Container, Row, Col, Card, CardImg } from "reactstrap";
import ExamplesNavbar from "../../components/Navbars/ExamplesNavbar";
import RecruitmentPageHeader from "../../components/Headers/RecruitmentPageHeader";
import DefaultFooter from "../../components/Footers/DefaultFooter";
import logoykbut from "assets/img/logo.png";

const RecruitmentPage = () => {
    const [recruitmentData, setRecruitmentData] = useState([]);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    useEffect(() => {
        AOS.init({
            duration: 800,
            easing: "ease-in-out",
            once: true,
        });

        const fetchData = async () => {
            try {
                const response = await axios.get(
                    `${process.env.REACT_APP_API_URL}/recruit/readRecruit`,
                );
                setRecruitmentData(response.data);
            } catch (error) {
                console.error("Error fetching recruitment data:", error);
            }
        };

        fetchData();

        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    // Split the data to display around the logo
    const rightImages = recruitmentData.slice(0, 2);
    const bottomImages = recruitmentData.slice(2, 5);

    return (
        <>
            <ExamplesNavbar />
            <div className="wrapper">
                <RecruitmentPageHeader />
                <div className="section">
                    <Container style={{ maxWidth: "1200px", margin: "0 auto" }}>
                        {/* Row for logo and right-side images */}
                        <Row style={{ alignItems: "center", marginBottom: "-18px" }}>
                            <div>
                                <img src="/images/undermaintenance.jpg" alt="Under Maintenance" />
                            </div>
                            {/* Logo spanning the left side */}
                            {/* <Col sm="8" style={{ marginTop: "20px" }}>
                                <Card
                                    style={{
                                        backgroundColor: "#f6f6f6",
                                        padding: "20px",
                                        textAlign: "center",
                                        border: "none",
                                        boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
                                        marginTop: "20px",
                                    }}
                                    data-aos="fade-up"
                                >
                                    <CardImg
                                        top
                                        src={logoykbut}
                                        alt="Logo YKBUT"
                                        className="img-fluid"
                                        style={{
                                            width: "83%",
                                            height: isMobile ? "auto" : "405px",
                                        }}
                                    />
                                </Card>
                            </Col> */}

                            {/* Right side images */}
                            {/* <Col sm="4" style={{ marginTop: "38px" }}>
                                {rightImages.map((item, index) => (
                                    <Card
                                        key={index}
                                        data-aos="fade-up"
                                        style={{ marginBottom: "32px" }}
                                    >
                                        <a
                                            href={item.link}
                                            target="_blank"
                                            rel="noreferrer noopener"
                                        >
                                            <CardImg
                                                top
                                                src={item.images}
                                                alt={`recruitment-right-${index}`}
                                                className="img-fluid"
                                                style={{ width: "100%", height: "auto" }}
                                            />
                                        </a>
                                    </Card>
                                ))}
                            </Col> */}
                        </Row>

                        {/* Bottom row images */}
                        {/* <Row className="justify-content-center" style={{ marginTop: "20px" }}>
                            {bottomImages.map((item, index) => (
                                <Col
                                    sm="4"
                                    key={index}
                                    style={{ display: "flex", justifyContent: "center" }}
                                >
                                    <Card data-aos="fade-up" style={{ maxWidth: "100%" }}>
                                        <a
                                            href={item.link}
                                            target="_blank"
                                            rel="noreferrer noopener"
                                        >
                                            <CardImg
                                                top
                                                src={item.images}
                                                alt={`recruitment-bottom-${index}`}
                                                className="img-fluid"
                                                style={{ width: "100%", height: "auto" }}
                                            />
                                        </a>
                                    </Card>
                                </Col>
                            ))}
                        </Row> */}
                    </Container>
                </div>
                <DefaultFooter />
            </div>
        </>
    );
};

export default RecruitmentPage;
